import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  formWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: SPACES.xxxl,

      padding: SPACES.xxxxxl,

      minWidth: '320px',
      minHeight: 'auto',

      [theme.breakpoints.down('tablet_s')]: {
        padding: SPACES.xxl,
      },
    },
  },
  formTitle: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      textAlign: 'center',
      maxWidth: '100%',
      margin: 'auto',
      marginTop: '5px',

      [theme.breakpoints.down('tablet_s')]: {
        maxWidth: '60%',
        marginTop: 0,

        '& .MuiTooltip-tooltip': {
          width: '170px',
        },
      },
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.l,
    flex: 1,
  },
  formInner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: SPACES.s,
  },
}))
